module.exports = __webpack_public_path__ + "static/media/muniEscudo.89495565.png";